// extracted by mini-css-extract-plugin
module.exports = {"buttonEnter":"styles_buttonEnter__1u9yu","animateText":"styles_animateText__gZhtE"};